import React from 'react';

const ErrorPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 relative overflow-hidden flex items-center justify-center">
            {/* Dotted Background */}
            <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0" style={{
                    backgroundImage: 'radial-gradient(circle, #dc2626 1px, transparent 1px)',
                    backgroundSize: '20px 20px'
                }}></div>
            </div>
            
            {/* Content */}
            <div className="text-center relative z-10 max-w-2xl mx-auto px-6">
                <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold text-red-600 mb-8 tracking-tight leading-none">
                    Erreur
                </h1>
                <div className="space-y-4">
                    <p className="text-xl md:text-2xl text-gray-700 font-medium">
                        Nous sommes désolés, mais une erreur inattendue s'est produite.
                    </p>
                    <p className="text-base text-gray-500">
                        Veuillez contacter l'administrateur système pour résoudre ce problème.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
